// or your router
import { DetailedHTMLProps, HTMLAttributes } from "react";
import { ExtraProps } from "react-markdown";

import AppTypography from "../../Text/AppTypography";
import { MarkdownElCommonProps } from "../MarkdownRenderer";

type Props = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> &
  ExtraProps &
  MarkdownElCommonProps & {
    variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  };

/** <h></h> element. */
export function MarkdownHeadingEl({
  variant,
  isUseDefaultMargins,
  sx,
  node,
  children,
  ...otherProps
}: Props) {
  return (
    <AppTypography
      sx={{
        ...(isUseDefaultMargins && {
          ...(variant === "h1" && { mt: 4, mb: 1.5 }),
          ...(variant === "h2" && { mt: 3, mb: 1.5 }),
          ...(variant === "h3" && { mt: 2, mb: 1.5 }),
          ...(variant === "h4" && { mt: 1.5, mb: 1 }),
          ...(variant === "h5" && { mt: 1.25, mb: 1 }),
          ...(variant === "h6" && { mt: 1, mb: 1 }),
        }),
        "&:first-child": {
          mt: 0,
        },
        ...sx,
      }}
      component={variant}
      variant={variant}
      {...otherProps}
    >
      {children}
    </AppTypography>
  );
}
